module.exports = __webpack_public_path__ + "img/logo-grey.c1460913.svg";